import useComponentMountMetric from '../metrics/useComponentMountMetric';
import PropertyInputExpandableText from './PropertyInputExpandableText';
import TextAreaPopover from './textarea/components/TextAreaPopover';
import { jsx as _jsx } from "react/jsx-runtime";
export const PropertyInputTextArea = props => {
  useComponentMountMetric('PropertyInputTextArea');
  const {
    formControlUse
  } = props;
  if (formControlUse === 'table-cell') {
    return /*#__PURE__*/_jsx(TextAreaPopover, Object.assign({}, props));
  }
  return /*#__PURE__*/_jsx(PropertyInputExpandableText, Object.assign({}, props));
};
export default PropertyInputTextArea;